import React from 'react';
import {FileUploader} from "react-drag-drop-files";

const FileUploadComponent = ({handleChange, fileTypes}) => {
    return (
        <div className=" w-3/4 sm:w-10/12 h-32 sm:h-28 bg-white/25 border-white rounded-lg border-3 border-solid">

            <FileUploader
                handleChange={handleChange}
                name="file"
                types={fileTypes}
                classes={`w-full bg-white cursor-pointer`}
            >
                <div className={"w-full h-full flex flex-col text-sm lg:text-lg items-center py-4 px-2 sm:px-0 sm:py-2"}>
                    <div className="">
                        <i className="ri-upload-2-line bg-purple-dashboard text-base lg:text-lg p-1 rounded-lg" />
                    </div>
                    <div className="flex justify-center">Click to upload or drag and drop</div>
                    <div className="flex justify-center px-4 sm:px-0">SVG, PNG, JPG or GIF (max. 800x400px)</div>
                </div>
            </FileUploader>
        </div>
    );
};

export default FileUploadComponent;